var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-button-group',{attrs:{"stretch":""}},[_c('form-button',{attrs:{"icon":"plus","href":_vm.creating}},[_vm._v("\n    Adicionar veículo\n  ")]),_c('filter-button',{attrs:{"active":_vm.active,"action":"usedVehicles/filter"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }